import { z } from "zod";

/**
 * None auth — no authentication required.
 * Used for public APIs. getCredentials() returns empty headers and the
 * request goes through without any Authorization header.
 */
export const CustomManifestNoneSchema = z.object({
  type: z.literal("none")
});

export type CustomManifestNone = z.infer<typeof CustomManifestNoneSchema>;
